import { useState } from 'react';

import { isAttachmentAddEnabled } from '@/feature/attachment.feature';
import { ListViewItem } from '@ingka/list-view';
import paperclip from '@ingka/ssr-icon/paths/paperclip';
import { selectAttachments } from '@repo/api-adapters/selectors/attachments.selectors';
import { translate } from '@repo/phrase';
import { useRegisterCommands } from '@sp-saljapro/command-menu/react';

import { useAssetActionButton } from '@/components/asset-details/asset-action-buttons/asset-action-buttons.hooks';

import { useAsset, useAssetParams } from '@/hooks/asset.hooks';
import { trackCommand } from '@/utils/command-menu.utils';
import { getAppConfig } from '@/utils/window.utils';

import { AttachmentsModal } from './attachments-modal.component';

export const AttachmentsSection = () => {
    const { assetId, assetType } = useAssetParams();
    const { data } = useAsset(assetType, assetId);
    const attachmentsCount = selectAttachments(data).length;
    const { isModificationButtonDisabled, isButtonDisabled } = useAssetActionButton();
    const commandMenuEnabled = getAppConfig().feature.commandMenu?.enable;
    const [isOpen, setIsOpen] = useState(false);
    const [shouldOpenUploadDialog, setShouldOpenUploadDialog] = useState(false);

    const close = () => {
        setIsOpen(false);
        setShouldOpenUploadDialog(false);
    };

    const open = () => {
        setIsOpen(true);
    };

    useRegisterCommands({
        enabled: commandMenuEnabled && isAttachmentAddEnabled(assetType),
        commands: [
            {
                id: 'asset:upload-attachment',
                keys: ['U'],
                description: translate('command_menu_upload_attachment'),
                group: translate('command_menu_orders_group_actions'),
                enabled: () => !isModificationButtonDisabled && !isButtonDisabled,
                onSelect: (source) => {
                    trackCommand('asset:upload-attachment', source);
                    setIsOpen(true);
                    setShouldOpenUploadDialog(true);
                },
            },
        ],
    });

    return (
        <>
            <ListViewItem
                id="asset-attachments"
                control="navigational"
                emphasised
                controlIcon="chevronRight"
                leadingIcon={paperclip}
                title={translate('asset_details_attachments')}
                description={translate('asset_details_attachments_description', { number: `${attachmentsCount}` })}
                onClick={open}
                showDivider
            />
            <AttachmentsModal
                visible={isOpen}
                onClose={close}
                shouldOpenUploadDialog={shouldOpenUploadDialog}
                onUploadDialogRequestHandled={() => {
                    setShouldOpenUploadDialog(false);
                }}
            />
        </>
    );
};
